import { getDefaultTimezoneMoment, getPeriodByBaseMoment, getBaseMomentByNoonGap } from '../../lib/renderUtil'

class DateHelper {
  // 訂購概況 查詢區間 (預設查詢區間為當月 1 日至當日前一天、每日中午更新
  getSaleStatDefaultPeriod = (base) => {
    /*
      訂購概況 資料查詢區塊時間預設值
      資料查詢區塊
      僅接受半年內之資料查詢
      起：兩年以前之日期不可選擇
      迄且現在是 12:00:00 以後：今天(含)以後之日期不可選擇
      迄且現在是 11:59:59 以前：前一天(含)以後之日期不可選擇
    */
    // convert base moment to default timezone (+8)
    const baseMoment = base || getDefaultTimezoneMoment(getBaseMomentByNoonGap())
    const periodMomentObject = getPeriodByBaseMoment(baseMoment)
    const startMinDate = baseMoment.clone().subtract(730, 'days').format('YYYY/MM/DD')
    const saleAnalysisStartMinDate = baseMoment.clone().subtract(12, 'months').format('YYYY/MM/DD')
    const endMaxDate = periodMomentObject.end.clone().format('YYYY/MM/DD')
    const start = periodMomentObject.start.format('YYYY/MM/DD')
    const end = periodMomentObject.end.format('YYYY/MM/DD')
    return {
      start,
      end,
      startMinDate,
      endMaxDate,
      saleAnalysisStartMinDate
    }
  }
}

export default new DateHelper()
